<template>
  <login-layout>
    <form
      class="flex flex-col mt-12 items-center"
      @submit.prevent="handleLogin"
    >
      <h1 class="form__title">Anmelden digitastic.plus</h1>
      <label
        for="username"
        class="text-dark-blue-1000 text-xxs flex flex-col uppercase font-semibold w-full"
      >
        BENUTZERNAME
      </label>
      <dp-input
        v-model="username"
        id="username"
        ref="username"
        class="mt-2"
      ></dp-input>

      <label
        for="password"
        class="text-dark-blue-1000 text-xxs flex flex-col mt-5 w-full font-semibold uppercase"
      >
        PASSWORT
      </label>
      <dp-input
        v-model="password"
        id="password"
        type="password"
        class="mt-2"
        password
      ></dp-input>

      <dp-button
        class="submidbtn"
        native-type="submit"
        type="primary"
        style="margin-top: 64px; margin-left: 8rem"
        :loading="submitted"
      >
        Anmelden
      </dp-button>
    </form>
    <a
      href="https://my.digitastic.app/#/forgot-password"
      class="text-xs mt-10 flex text-blue-900 mx-auto hover:text-blue-700"
    >
    </a>
  </login-layout>
</template>

<script>
import LoginLayout from "../layouts/Login";
import { authMethods } from "../state/helpers";
import { DATA_DECRYPTER } from "../utils";

export default {
  name: "Login",
  components: {
    LoginLayout,
  },
  props: {
    encryptedUsername: {
      type: String,
      default: "",
    },
    encryptedPassword: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
    };
  },
  created() {
    localStorage.setItem("quaryCc", this.$store.getters.getLinkquarycc);
    localStorage.setItem("quaryName", this.$store.getters.getLinkquaryname);
    localStorage.setItem(
      "quaryStartDate",
      this.$store.getters.getLinkStartDate
    );
    localStorage.setItem("quaryEndDate", this.$store.getters.getLinkEndDate);
    const { encryptedUsername, encryptedPassword } = this;
    if (encryptedUsername !== "" && encryptedPassword !== "") {
      window.localStorage.clear();
      const decryptedUsername = DATA_DECRYPTER(
        encryptedUsername,
        "digitasticTeam"
      );
      const decryptedPassword = DATA_DECRYPTER(
        encryptedPassword,
        "digitasticTeam"
      );

      this.username = decryptedUsername;
      this.password = decryptedPassword;
      this.handleLogin();
    }
  },
  methods: {
    ...authMethods,
    handleLogin() {
      this.submitted = true;
      if (this.username !== "" && this.username !== "") {
        const { username, password } = this;
        this.logIn({ username, password })
          .then(() => {
            this.submitted = false;
            this.username = "";
            this.password = "";
            this.$router.push({ name: "Report" });
          })
          .catch(() => {
            this.submitted = false;
            this.$Toast.error({
              message: "Der Username oder Passwort ist nicht korrekt.",
              duration: 3000,
            });
          });
      } else {
        this.submitted = false;
        this.$refs.username.focus();
        this.$Toast.error({
          message: "error",
          duration: 3000,
        });
      }
    },
  },
};
</script>
<style>
</style>


